import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setIsLogin, setRoleAction } from "../../redux/actions/roleAction";
import { useDispatch } from "react-redux";

import { useFormik } from "formik";
import { LoginSchema } from "../../schema";
import {
  setProfileData,
  setUserToken,
} from "../../redux/actions/profileAction";
import { loginApi } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

const initialValues = {
  email: "",
  password: "",
};

export const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (values, action) => {
    setIsLoading(true);
    loginApi(values)
      .then((response) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${response?.data?.message}`,
        });
        action.resetForm();
        setTimeout(() => {
          dispatch(setIsLogin(true));
          dispatch(setRoleAction(response.data.Data.UserDetails.role));
          dispatch(setProfileData(response.data.Data.UserDetails));
          dispatch(setUserToken(response.data.Data.UserDetails.token));
          navigate("/user-management");
        }, 1000);
        setIsLoading(true);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: LoginSchema,
      onSubmit: (values, action) => handleLogin(values, action),
    });

  return (
    <>
      <div className="all-login-signup-forgot-pass-model">
        <Toast ref={toast} />

        {isLoading && (
          <div class="set-proper-line-in-all-page">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <div className="loop-text-cls-add">
          <h1>The Loop</h1>
        </div>
        <div class="auth_screen">
          <div class="row">
            <div class="col-lg-12">
              <div class="auth_box">
                <div class="auth_body mt-4 w-100">
                  <h6 class="mb-4">Welcome</h6>
                  <form onSubmit={handleSubmit} class="">
                    <div class="form-content">
                      <div class="form-group">
                        <label class="form-label all-label-same">Email</label>
                        <input
                          type="email"
                          name="email"
                          maxlength="50"
                          class="form-control input-underline input-lg"
                          placeholder="Email Id"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.email && touched?.email ? (
                          <p className="form-error">{errors.email}</p>
                        ) : null}
                      </div>
                      <div class="form-group mb-2 mt-4">
                        <div class="d-flex justify-content-between">
                          <label class="form-label all-label-same">
                            Password
                          </label>
                          <Link class="link_txt" to="/forgot-password">
                            Forgot Password?
                          </Link>
                        </div>

                        <input
                          type="password"
                          name="password"
                          maxlength="30"
                          class="form-control input-underline input-lg "
                          placeholder="Password"
                          values={values.password}
                          errors={errors.password}
                          touched={touched.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.password && touched.password ? (
                          <p className="form-error">{errors.password}</p>
                        ) : null}
                      </div>
                      <div class="user_link mt-2">
                        <label class="checkbox_container">
                          Keep Login
                          <input type="checkbox" />
                          <span class="checkmark"></span>
                        </label>
                        <div class="row mt-4 mb-2">
                          <div class="col-lg-12 text-center">
                            <button
                              type="submit"
                              class="btn fill_btn same-all-btn-primary"
                              // onClick={handleLogin}
                            >
                              login
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
